import { render, staticRenderFns } from "./IndustryNewsListItem.vue?vue&type=template&id=7404b6e1&scoped=true"
import script from "./IndustryNewsListItem.vue?vue&type=script&lang=js"
export * from "./IndustryNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./IndustryNewsListItem.vue?vue&type=style&index=0&id=7404b6e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7404b6e1",
  null
  
)

export default component.exports